import { render } from "./DaftarAlbumDokumen.vue?vue&type=template&id=df9ef2d6"
import script from "./DaftarAlbumDokumen.vue?vue&type=script&lang=js"
export * from "./DaftarAlbumDokumen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__